import * as moment from "moment";
import * as StripeTypes from "../../Common/Stripe/types";

export interface IAppointmentRequestBase {
    type?: string;
}

export interface IAppointmentRequest extends IAppointmentRequestBase {
    serviceId?: number;
    locationId?: number;
    providerId?: number;
}

export interface IDateRequest extends IAppointmentRequestBase {
    locationId?: number;
    providerId?: number;
    serviceId?: number;

    month: number;
    year: number;

    availabilityType: AvailabilityType;
    enableTimezones: boolean;

    clientUtcOffset: number;
}

export enum AvailabilityType {
    Unspecified,
    Available,
    Class,
}

export interface IBookRequest extends IAppointmentRequestBase, StripeTypes.IIdempotencyKeyModel {
    clientId?: number;
    appointmentId?: number;
    locationId: number;
    providerId: number;
    serviceId: number;
    date: moment.Moment;
    offset: number;
    durationMinutes: number;
    notes: string;
    paymentIntentId?: string;
    hasTotalAmount: boolean;
    clientLogs?: string;
}
